import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { Box, keyframes, Stack, Typography, useTheme } from '@mui/material';

const shimmerSweep = keyframes`
    0% { transform: translateX(-120%) skewX(-12deg); }
    100% { transform: translateX(220%) skewX(-12deg); }
`;

const scanLine = keyframes`
    0% { top: 0%; opacity: 0.4; }
    10% { opacity: 1; }
    90% { opacity: 1; }
    100% { top: calc(100% - 2px); opacity: 0.4; }
`;

const pulseGlow = keyframes`
    0%, 100% { opacity: 0.55; }
    50% { opacity: 1; }
`;

interface Props {
    fileName: string;
}

export default function ScanOverlay({ fileName }: Props) {
    const theme = useTheme();

    return (
        <Box
            sx={{
                position: 'absolute',
                inset: 0,
                borderRadius: '6px',
                overflow: 'hidden',
                pointerEvents: 'none',
            }}
        >
            <Box
                sx={{
                    position: 'absolute',
                    inset: 0,
                    background: `linear-gradient(135deg, ${theme.palette.primary.main}22 0%, rgba(103, 58, 183, 0.15) 50%, ${theme.palette.primary.main}18 100%)`,
                }}
            />
            <Box
                sx={{
                    position: 'absolute',
                    inset: 0,
                    background:
                        'linear-gradient(105deg, transparent 40%, rgba(255,255,255,0.55) 50%, transparent 60%)',
                    animation: `${shimmerSweep} 2.2s ease-in-out infinite`,
                }}
            />
            <Box
                sx={{
                    position: 'absolute',
                    left: 0,
                    right: 0,
                    height: '2px',
                    background: `linear-gradient(90deg, transparent, ${theme.palette.primary.main}, #7c4dff, transparent)`,
                    boxShadow: `0 0 12px ${theme.palette.primary.main}`,
                    animation: `${scanLine} 2.4s ease-in-out infinite`,
                }}
            />
            <Stack
                direction="row"
                alignItems="center"
                spacing={0.75}
                sx={{
                    position: 'absolute',
                    bottom: 8,
                    left: 8,
                    right: 8,
                    px: 1,
                    py: 0.5,
                    borderRadius: '4px',
                    bgcolor: 'rgba(255, 255, 255, 0.92)',
                    backdropFilter: 'blur(4px)',
                    animation: `${pulseGlow} 1.8s ease-in-out infinite`,
                }}
            >
                <AutoAwesomeIcon sx={{ fontSize: 14, color: theme.palette.primary.main }} />
                <Typography variant="caption" fontWeight={600} color="primary" noWrap>
                    AI scanning {fileName}
                </Typography>
            </Stack>
        </Box>
    );
}
